// cyko-hover-menu.js
// Header menu hover — desktop only
(function () {
  if (window.innerWidth < 990) return;

  document.querySelectorAll('.header__inline-menu li').forEach(function (li) {
    var details = li.querySelector('header-menu > details.mega-menu');
    if (!details) return;

    var timer;

    li.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      details.setAttribute('open', '');
    });

    li.addEventListener('mouseleave', function () {
      timer = setTimeout(function () {
        details.removeAttribute('open');
      }, 100);
    });
  });
})();